import { useState } from "react";
import moment from "moment";
import Box from "../../components/Box";
import AlertBox from "../../components/AlertBox";
import MainLayout from "../../components/layouts/MainLayout";
import Pagination from "../../components/Pagination";
// import { useControlPermission } from "../../utils/ActionPermissionUtils";
import ModalDownloadCustomerPartner from "../../components/customer/ModalDownloadCustomerPartner";
import { useReportReactivationsHooks } from "../../utils/customer/CustomerReqReprotUtil";

export default function ReportCustomerReactivationPage() {
  // const { hasAccess } = useControlPermission();

  const [formFilter, setFormFilter] = useState({
    q: "",
    start_date: "",
    end_date: "",
  });
  const [filter, setFilter] = useState({
    q: "",
    start_date: "",
    end_date: "",
    page: 1,
    page_size: 20,
  });

  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [modal, setModal] = useState(null);
  const { reactivationData, meta, loading, errorMsg, getReportActivations } =
    useReportReactivationsHooks({
      filter,
    });

  function applyFilter() {
    let form_filter = {
      ...filter,
      ...formFilter,
      page: 1,
    };
    setFilter(form_filter);
  }

  const resetFilter = () => {
    setFormFilter({
      q: "",
      start_date: "",
      end_date: "",
    });
    setFilter({
      q: "",
      start_date: "",
      end_date: "",
      page: 1,
      page_size: 10,
    });
  };

  const changeFilter = (name, value) => {
    setFormFilter({ ...formFilter, [name]: value });
  };

  const onSuccess = (message) => {
    getReportActivations(filter);
    setAlert({ show: true, message: message, type: "success" });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <MainLayout resource_key="partner-infrastructure">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Laporan Reaktivasi Pelanggan</h1>
          </div>
          <div className="col-auto">
            {/* {hasAccess("export-partner-infrastructure-customer") && (
              <button className="btn btn-primary" onClick={() => setModal("download")}>
                <i className="fas fa-download"></i> Unduh Data Pelanggan
              </button>
            )} */}
          </div>
        </div>

        <Box title={`Daftar Pelanggan (Total Data: ${meta.count})`} loading={loading}>
          <div className="mb-4">
            <div className="row">
              <div className="col-12 col-md-2">
                <div className="form-group">
                  <label htmlFor="querysearch">Pencarian</label>
                  <input
                    type="text"
                    name="querysearch"
                    value={formFilter.q}
                    placeholder="Pencarian ..."
                    onChange={(event) => changeFilter("q", event.target.value)}
                    className="form-control"
                    id="querysearch"
                  />
                </div>
              </div>
              <div className="col-12 col-md-2">
                <div className="form-group">
                  <label htmlFor="startdateform">Tanggal Reaktivasi Mulai</label>
                  <input
                    type="date"
                    name="startdateform"
                    value={formFilter.start_date}
                    onChange={(event) => changeFilter("start_date", event.target.value)}
                    className="form-control"
                    id="startdateform"
                  />
                </div>
              </div>
              <div className="col-12 col-md-2">
                <div className="form-group">
                  <label htmlFor="enddateform">Tanggal Reaktivasi Akhir</label>
                  <input
                    type="date"
                    name="enddateform"
                    value={formFilter.end_date}
                    onChange={(event) => changeFilter("end_date", event.target.value)}
                    className="form-control"
                    id="enddateform"
                  />
                </div>
              </div>
              <div className="col-auto">
                <button
                  className="btn btn-primary"
                  onClick={() => applyFilter()}
                  style={{ marginTop: "32px" }}
                >
                  Filter
                </button>
                <button
                  className="btn btn-default"
                  onClick={() => resetFilter()}
                  style={{ marginTop: "32px" }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
          <AlertBox {...alert} setAlert={setAlert} />

          <div style={{ overflowX: "auto" }}>
            <table className="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th rowSpan={2}>Tgl. Reaktivasi</th>
                  <th colSpan={2}>Pelanggan Lama</th>
                  <th colSpan={2}>Pelanggan Baru</th>
                  <th rowSpan={2}>Reaktivasi Oleh</th>
                  <th rowSpan={2}>Catatan</th>
                </tr>
                <tr>
                  <th>No. Registrasi</th>
                  <th>Nama</th>
                  <th>No. Registrasi</th>
                  <th>Nama</th>
                </tr>
              </thead>
              <tbody>
                {reactivationData.length === 0 && (
                  <tr>
                    <td colSpan={7} className="text-center">
                      Tidak ada data
                    </td>
                  </tr>
                )}
                {reactivationData.map((reactviation, index) => (
                  <tr key={index}>
                    <td className="text-nowrap">
                      {moment.unix(reactviation.reactivated_at).format("DD MMM YYYY - HH:mm")}
                    </td>
                    <td>{reactviation.old_customer.registration.registration_number}</td>
                    <td className="text-nowrap">{reactviation.old_customer.name}</td>
                    <td>{reactviation.new_customer.registration.registration_number}</td>
                    <td className="text-nowrap">{reactviation.new_customer.name}</td>
                    <td>{reactviation.reactivated_by.name}</td>
                    <td>{reactviation.note}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {meta.count > meta.page_size && (
            <Pagination
              totalpage={Math.ceil(meta.count / meta.page_size)}
              selectedpage={meta.page}
              clickpage={(page) => gotoPage(page)}
              next={() => gotoPage(meta.page + 1)}
              prev={() => gotoPage(meta.page - 1)}
            />
          )}
        </Box>
      </div>
      <ModalDownloadCustomerPartner
        show={modal === "download"}
        onClose={() => setModal(null)}
        onSuccess={onSuccess}
      />
    </MainLayout>
  );
}
